import { gql } from '@apollo/client'
import {
	ClientEntity,
	SalePayment,
	SalesPaging
} from '../../../../client/graphql'

type SalesResponseList = SalesPaging['list'][number]

export type SalesResponse = {
	list: Array<{
		_id: SalesResponseList['_id']
		reference: SalesResponseList['reference']
		segment: SalesResponseList['segment']
		amount: number
		happenedAt: SalesResponseList['happenedAt']
		currency: SalesResponseList['currency']
		payment: SalePayment
		products: Array<{
			tariffCode: string
			startDate: string
			endDate: string
		}>
		channels: Array<{
			channel: string
		}>
		client: ClientEntity
	}>
	paging: SalesPaging['paging']
}

export const SalesGql = gql`
	query Sales(
		$limit: Int
		$page: Int
		$order: String
		$tariffCode: String
		$state: String
		$productBeginEnd: [DateTime!]
	) {
		sales(
			limit: $limit
			page: $page
			order: $order
			tariffCode: $tariffCode
			state: $state
			productBeginEnd: $productBeginEnd
		) {
			list {
				_id
				segment
				source
				amount
				currency
				payment {
					mean {
						type
						provider
						pan
					}
				}
				products {
					tariffCode
					startDate
					endDate
				}
				channels {
					channel
				}
				client {
					name
				}
			}
			paging {
				current
				count
				limit
			}
		}
	}
`
